import ClaimDocumentTypes from "@upclaim/prisma/seeds/claims_documents_types.json";
import { ClaimDocumentType } from "@/interfaces/data-contracts";

export type DocumentType = ClaimDocumentType['type'];

const DocumentTypesMap = new Map(ClaimDocumentTypes.map(ct => [ct.type as DocumentType, ct]));

const typeTranslations: { [key in DocumentType]: string } = {
  "OTHER": "Autre",
  "MED": "Mise en Demeure",
  "LEGAL_SUBPOENA_SERVED": "Assignation notifiée",
  "LEGAL_SUBPOENA_TO_REVIEW": "Assignation à valider", 
  "DEBT_CONTRACT": "Cession de créance",
  "CLAIM_NOTIFICATION": "Notification cession de créance",
  "INVOICES_MERGED": "Factures fusionnées",
  "KBIS_UPCLAIM": "KBIS société Upclaim",
  "ELIGIBILITY_PROOF": "Preuve d'éligibilité",
  "RIB_UPCLAIM": "RIB du dossier",
  "FIRST_CONCILIATION_ATTEMPT": "Première tentative de conciliation",
  "MED_RECEIPT": "Avis de réception MED",
  "ESCP_A": "Formulaire A (ESPC)",
  "ESCP_B": "Formulaire B (ESPC)",
  "ESCP_C": "Formulaire C (ESPC)",
  "ESCP_D": "Formulaire D (ESPC)",
  "COURT_DECISION": "Décision de tribunal",
  "PLEADING_FILE": "Dossier de plaidoirie",
  "KBIS_OPPONENT": "KBIS société adverse",
  "ID_PROOF": "Carte(s) d'identité",
  "ETICKET": "E-ticket(s)",
  "DEBT_CONTRACT_ENTERPRISE": "Cession entreprise envers Upclaim",
  "DEBT_CONTRACT_TRAVEL_AGENCY_TO_UPCLAIM": "Cession agence envers Upclaim",
  "PROOF_OF_EXPENSE": "Justificatif de dépense",
  "RECEIVABLE_TRAIL": "Dossier de preuve Signature",
};

/** This is a quick fix @TODO add permissions to the main object */
const typeForAgent: { [key in DocumentType]?: string } = {
  "DEBT_CONTRACT": "Signature Passager",
  "ID_PROOF": "Carte(s) d'identité",
  "ETICKET": "E-ticket(s)",
  "ELIGIBILITY_PROOF": "Preuve d'annulation / retard",
  "INVOICES_MERGED": "Factures",
  "DEBT_CONTRACT_ENTERPRISE": "Cession de créance Entreprise",
  "OTHER": "Autre",
}

export {
  typeTranslations,
  typeForAgent
}